import { checkAuth } from './auth';
import {
    SAVE_ELEMENT_REQUEST,
    REMOVE_ELEMENT_REQUEST,
    GET_SAVED_ELEMENT_SUCCESS,
    GET_SAVED_ELEMENT_REQUEST,
    GET_PROVIDED_ELEMENT_SUCCESS,
    GET_PROVIDED_ELEMENT_REQUEST,
} from '../actionTypes';

export const saveElement = (payload) =>
    checkAuth({ type: SAVE_ELEMENT_REQUEST, payload });

export const getProvidedElement = (filter) => ({
    filter,
    isPrivate: false,
    type: GET_PROVIDED_ELEMENT_REQUEST,
});

export const getElementSuccess = (payload) => {
    return { ...payload, type: GET_PROVIDED_ELEMENT_SUCCESS };
};

export const getSavedElement = (filter) =>
    checkAuth({
        filter,
        isPrivate: true,
        type: GET_SAVED_ELEMENT_REQUEST,
    });

export const getSavedElementSuccess = (payload) => ({
    ...payload,
    type: GET_SAVED_ELEMENT_SUCCESS,
});

export const removeElement = (id) =>
    checkAuth({
        id,
        type: REMOVE_ELEMENT_REQUEST,
    });
